import GpsCargoOrderRecordsRequest from "../../../api/raily/gps/cargo-order-records/gps-cargo-order-records-request";
import GpsCargoOrderRecordsParams from "./gps-cargo-order-records-params";

const create = (
  params: GpsCargoOrderRecordsParams,
): GpsCargoOrderRecordsRequest => {
  return {
    orderUuid: params.orderUuid,
  };
};

const gpsCargoOrderRecordsParamsFactory = {
  create,
};

export default gpsCargoOrderRecordsParamsFactory;
